module.exports = __webpack_public_path__ + "static/media/19ESCAP12.3fdfe35b.jpg";